import { useTranslation } from 'react-i18next';

interface MyProfileRoleBadgesProps {
  roles: readonly string[];
  isRoot: boolean;
}

// PRD 20 §2.2 row 14 — Root renders as a single red 👑 badge, otherwise show
// each held role as an outline badge. Empty roles + !isRoot shows a muted "no role" hint.
export function MyProfileRoleBadges({ roles, isRoot }: MyProfileRoleBadgesProps) {
  const { t } = useTranslation('my-profile');

  if (isRoot) {
    return (
      <span
        className="badge"
        style={{ background: '#fee', color: '#c00', fontWeight: 600 }}
      >
        {t('cards.info.badges.root')}
      </span>
    );
  }
  if (roles.length === 0) {
    return (
      <span style={{ color: 'var(--muted-foreground)', fontSize: 12 }}>
        {t('cards.info.badges.noRoles')}
      </span>
    );
  }
  return (
    <>
      {roles.map((r) => (
        <span key={r} className="badge badge-outline" style={{ fontSize: 12 }}>
          {r}
        </span>
      ))}
    </>
  );
}
